
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { isEmail } from '@/utils/validate'
import { setToken, getToken } from '@/utils/cookies'
// import VantaNet from '@/components/Vanta/Net.vue'
import http from '@/utils/request'
import { setUserInfo } from '@/utils/user'
import { UserLoginResponse, UserType } from './user.interface'
import { isIframeUrl } from '@/utils/env-config'
import i18n from '@/lang'

@Component({
  // components: { VantaNet }
  })
export default class Login extends Vue {
  private validateEmail = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error(i18n.t('Email is required') as string))
    } else if (!isEmail(value)) {
      callback(new Error(i18n.t('Email is not correct') as string))
    } else {
      callback()
    }
  }

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error(i18n.t('Password is required') as string))
    } else {
      callback()
    }
  }

  private loginFormRef!: ElForm

  private form = {
    email: '',
    loginPassword: ''
  }

  private rules = {
    email: [{ validator: this.validateEmail, trigger: 'change' }],
    loginPassword: [{ validator: this.validatePassword, trigger: 'change' }]
  }

  async onSubmit() {
    try {
      await this.loginFormRef.validate()
      const data = await http.post<UserLoginResponse>('/user/emailLogin', this.form, {
        disableError: true
      })
      if (data.tenantId) {
        setUserInfo(data)
        setUserInfo('email', this.form.email)
        setToken(data.cookieToken)

        switch (data.userType) {
          case UserType.INDIVIDUAL:
            if (!data.digisignFlag) {
              // Go to registerDigisign
              this.$router.push({ path: '/register/digisign' })
            } else if (!data.accountFlag) {
              // Go to registerRDL
              this.$router.push({ path: '/register/rdl' })
            } else {
              // Go to workbench
              this.$router.push({ path: '/dashboard' })
            }
            break
          case UserType.ENTERPRISE:
            if (data.step === null) {
              // Go to workbench
              this.$router.push({ path: '/dashboard' })
            } else if (data.step === 2) {
              // Go to Third-party binding
              this.$router.push({ path: '/register/third-party-binding' })
            } else if (data.step === 3) {
              // Go to supplementary information
              this.$router.push({ path: '/register/supplementary' })
            } else {
              //
            }
            break
        }
      } else {
        this.$message.error(i18n.t('Email or password is not correct') as string)
      }
    } catch (e) {}
  }

  onRegister() {
    this.$router.push({ path: '/register/platform' }) // TODO Impletement using path: `/register`
  }

  hideLoader() {
    const loader = document.querySelector('.Loader-container')
    if (loader) {
      loader.setAttribute('style', 'display: none;')
    }
  }

  mounted() {
    this.loginFormRef = this.$refs.loginFormRef as ElForm
    this.hideLoader()
    if (process.env.NODE_ENV === 'development') {
      this.testForm()
    }
    window.addEventListener('message', (event) => {
      const baseUrl = event.origin
      if (isIframeUrl(event.origin)) {
        const receivedData = event.data
        if (receivedData.type === 'data') {
          const data = receivedData.content
          window.parent.postMessage({ type: 'acknowledge', status: 'success', data: data, email: receivedData.email }, baseUrl)
        }
      }
    }, false)
    window.parent.postMessage({ type: 'iframeLoaded' }, '*')
  }

  testForm() {
    this.form.email = 'shinexiong2023@gmail.com'
    this.form.loginPassword = 'password01'
  }
}
